import type { AnyFormApi } from '@tanstack/vue-form'

import { clearChangedNestedErrors } from '~/utils/clearChangedNestedErrors'
import { clearFormBlurError } from '~/utils/clearFormBlurError'
import { hasMetaErrors } from '~/utils/hasMetaErrors'

/**
 * Per-field verdicts only clear for the field that actually changed. The form-level (pathless)
 * verdict is not attributable to a single field, so any edit that touches it is treated as an
 * attempt to fix it.
 */
export const clearEditedFormErrors = <TFormData extends object>(
  form: AnyFormApi,
  edited: readonly (keyof TFormData & string)[],
  previous: TFormData,
  current: TFormData,
  clearFieldError: (field: keyof TFormData & string) => void
): void => {
  for (const name of edited) {
    clearFieldError(name)
    clearChangedNestedErrors(form, name, previous, current)
  }
  const hasFormBlurVerdict =
    form.store.state.errorMap.onBlur !== undefined ||
    form.getFieldMeta('')?.errorMap.onBlur !== undefined
  if (hasFormBlurVerdict) clearFormBlurError(form)
  if (hasMetaErrors(form.getFieldMeta(''))) {
    form.setFieldMeta('', (meta) => ({ ...(meta ?? {}), errorMap: {} }))
  }
}
